
import css from '../../css/toolbox.module.css';
import { toolBoxManagerTemplate } from './toolBoxManagerTemplate';
import { GROUP_TYPE } from '../structures/aqua/gridAqua';

export class ToolBoxGroupManager extends toolBoxManagerTemplate {
	constructor( modules, managers ) {
		super( modules, managers);
		this.managers.ToolBoxGroupManager = this;
	}

	async init() {
		
		//add css
		this._addStyle( 'toolboxStyle', css );

		document.querySelector( '#toolbox' ).innerHTML = '';
		this.modules.toolbox.init( { containerId: 'toolbox', buttonList: this.#getButtonList() } );

		//add horizontal lines
		this._addVLineAfterButton( 'laterals' );

		this.showing = {
			frontals: true,
			laterals: false,
			capillas: false,
			traversales: false
		};

		this.#setButtonClasses();
	}
	
	#getButtonList() {
		return this.#getGroupButtonList().
			concat( this.#get2Dto3DButton() );
	}

	#getGroupButtonList() {
		return [
			{
				title: 'show/hide frontals',
				containerId: 'utility2DContainer',
				name: 'frontals',
				icon: 'border_bottom',
				label: '',
				callback: async e => {
					//disable button while trigering event. Store targets since they may change during event
					const targets = { t: e.target, c: e.currentTarget };
					this.disable( targets.t, targets.c );
					this.showing.frontals = !this.showing.frontals;
					await this.trigger( 'onShowGroup', GROUP_TYPE.FRONTALES, this.showing.frontals );
					this.enable( targets.t, targets.c );
					this.#setButtonClasses();
				}
			},
			{
				title: 'show/hide laterals',
				containerId: 'utility2DContainer',
				name: 'laterals',
				icon: 'border_left',
				label: '',
				callback: async e => {
					//disable button while trigering event. Store targets since they may change during event
					const targets = { t: e.target, c: e.currentTarget };
					this.disable( targets.t, targets.c );
					this.showing.laterals = !this.showing.laterals;
					await this.trigger( 'onShowGroup', GROUP_TYPE.LATERALES, this.showing.laterals );
					this.enable( targets.t, targets.c );
					this.#setButtonClasses();
				}
			},
			{
				title: 'show/hide chappels',
				containerId: 'utility2DContainer',
				name: 'chappels',
				icon: 'border_vertical',
				label: '',
				callback: async e => {
					//disable button while trigering event. Store targets since they may change during event
					const targets = { t: e.target, c: e.currentTarget };
					this.disable( targets.t, targets.c );
					this.showing.capillas = !this.showing.capillas;
					await this.trigger( 'onShowGroup', GROUP_TYPE.CAPILLAS, this.showing.capillas );
					this.enable( targets.t, targets.c );
					this.#setButtonClasses();
				}
			},
			{
				title: 'show/hide traversals',
				containerId: 'utility2DContainer',
				name: 'traversals',
				icon: 'border_horizontal',
				label: '',
				callback: async e => {
					//disable button while trigering event. Store targets since they may change during event
					const targets = { t: e.target, c: e.currentTarget };
					this.disable( targets.t, targets.c );
					this.showing.traversales = !this.showing.traversales;
					await this.trigger( 'onShowGroup', GROUP_TYPE.TRAVERSALES, this.showing.traversales );
					this.enable( targets.t, targets.c );
					this.#setButtonClasses();
				}
			},
		];
	}

	#get2Dto3DButton() {
		return [
			{
				title: 'GoTo3D',
				containerId: 'drawContainer',
				name: 'GoTo3D',
				icon: 'arrow_back',
				label: '',
				callback: async e => {
					//disable button while trigering event
					const targets = { t: e.target, c: e.currentTarget };
					this.disable( targets.t, targets.c );
					await this.trigger( 'fromGroupto3D' );
					this.enable( targets.t, targets.c );
				}
			}
		];
	}

	
	#setButtonClasses() {
		const show = ( button, show ) => {
			if( !button ) return;
			button.classList.remove( 'showingGroup' );
			if( show ) button.classList.add( 'showingGroup' );
		};
		const frontal = document.querySelector( '#frontals' );
		show( frontal, this.showing.frontals );
		const lateral = document.querySelector( '#laterals' );
		show( lateral, this.showing.laterals );
		const chappel = document.querySelector( '#chappels' );
		show( chappel, this.showing.capillas );
		const traversal = document.querySelector( '#traversals' );
		show( traversal, this.showing.traversales );
	}
}